export default __webpack_public_path__ + "30984ac728ddc1c8e29bd4f51a2a60d4.svg";